import { isStorySharesDecodableContent } from "@/view/utils/decodableContent";
import { IMetadata } from "@/view/utils/decodableContent";
import StorySharesLogo from "./StorysharesLogo";

interface DecodableContentProviderLogoProps {
  content: {
    content_type?: string;
    data?: {
      content_provider?: {
        slug?: string;
      };
    };
  };
  contentMetadata: IMetadata[];
}

const DecodableContentProviderLogo = ({
  content,
  contentMetadata,
}: DecodableContentProviderLogoProps) => {
  const isStorySharesDecodable = isStorySharesDecodableContent(
    content,
    contentMetadata,
  );

  /* When a Decodable article has the Storyshare content provider then display the Storyshare logo otherwise do not display any content provider logo. */

  return isStorySharesDecodable ? (
    <div>
      <StorySharesLogo />
    </div>
  ) : (
    <></>
  );
};

export default DecodableContentProviderLogo;
